'use client'; 

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export default function RecaptchaProviderWrapper({ children }: any) {
    const sitekey: any = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={sitekey}
            scriptProps={{
                async: true,              
                defer: true,               
                appendTo: "head",    
            }}
        >
            {children}
        </GoogleReCaptchaProvider>
    );
}
